import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import injectTranslate from 'i18n/hoc/injectTranslate'

import ProLayout from 'layouts/ProLayout/next'
import Content from './Content'

const ProHomePage = ({ translate, rawtranslate }) => (
  <ProLayout>
    <Helmet title={translate('pages.prohome.title')}>
      <meta
        name="description"
        content={translate('pages.prohome.meta.description')}
      />
      <script type="application/ld+json">
        {rawtranslate('pages.home.ld+json')}
      </script>
    </Helmet>
    <Content />
  </ProLayout>
)

ProHomePage.propTypes = {
  translate: PropTypes.func,
  rawtranslate: PropTypes.func,
}

export default injectTranslate(ProHomePage)
